<template>
  <MarkdownPost markdown-file="domain-driven-world-models.md" />
</template>

<script>
import MarkdownPost from '../MarkdownPost.vue'

export default {
  name: 'DomainDrivenWorldModels',
  components: {
    MarkdownPost
  }
}
</script>
